import * as api from '../../api/api-gestion-casos';
import { 
    GET_CONFIG_FORM,
    GET_COMBO_RECEPCIONAR,
    GET_RESPONSABLE_PREASIGNADO,
    GET_CMB_TIPO_GESTION,
    POST_RECEPCIONAR
} from '../types';

export const configuracionForm = (query) => ({
    type: GET_CONFIG_FORM,
    payload: api.getConfiguracionForm(query)
});
export const obtenerComboRecepcionar = (query) => ({
    type: GET_COMBO_RECEPCIONAR,
    payload: api.getDetallesConcepto(query)
});
export const postRecepcionarAction = (data) => ({
    type: POST_RECEPCIONAR,
    payload: api.postecepcionar(data)
});
export const obtenerResponsablePreAsignado = (query) => ({
    type: GET_RESPONSABLE_PREASIGNADO,
    payload: api.getResponsablePreAsignado(query)
});
export const obtenerComboTipoGestion = (query) => ({
    type: GET_CMB_TIPO_GESTION,
    payload: api.getDetallesConcepto(query)
});

